<template>
  <v-container>
    <v-container>
      <div>
        <v-row class="pt-6">
          <v-col cols="12">
            <h1 class="text-primary">Consensus Report</h1>
          </v-col>
          <v-col cols="12">
            <h4 class="text-primary">
              Choose one country below to see exogenous macro forecasts (first
              table) followed by endogenous market ones (second table). The
              former are end-of-quarter forecasts taken from the consensus. The
              latter are implied forecast trajectories generated by our model
              for the 52 weeks ahead. To download the results to Excel, click
              'Download' from 'Table.' To visualize the results before
              downloading them, click 'Chart' and choose the variable you want
              to see.
              <br />
              <br />
              Want to make some changes to the assumptions for the exogenous
              variables? Go to the
              <router-link to="/forecast-tool" color="primary">
                Medium-Term Forecast Tool.</router-link
              >
            </h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"> </v-col>
          <v-col cols="12"> </v-col>
          <v-col cols="12"></v-col>
          <v-col cols="2">
            <select
              name="LeaveType"
              @change="onChange($event)"
              class="form-control minimal"
              v-model="value"
            >
              <option
                v-for="item in getcontriesConsensusFilter"
                :value="item"
                v-bind:key="item.name"
              >
                {{ item.name }}
              </option>
            </select>
          </v-col>
          <v-col cols="12"></v-col>
          <v-col cols="12">
            <v-card contained-text variant="outlined">
              <v-table calculate-widths>
                <thead>
                  <tr>
                    <th class="text-center" style="width: 20%">Indicator</th>
                    <th
                      v-for="item in header[0]"
                      v-bind:key="item"
                      class="text-center"
                    >
                      {{ item }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts" :key="item.name">
                    <td
                      v-if="item.header"
                      class="text-left"
                      style="
                        background-color: var(--bg-2);
                        font-family: var(--f-body);
                        color: var(--text);
                        font-weight: bold;
                        font-size: 16px !important;
                      "
                    >
                      {{ item.name }}
                    </td>
                    <td
                      v-if="!item.header"
                      class="text-left"
                    >
                      {{ item.name }}
                    </td>
                    <td
                      v-for="a in item.data"
                      v-show="item.header"
                      v-bind:key="a"
                      class="text-center"
                      style="background-color: var(--bg-2)"
                    ></td>
                    <td
                      v-for="value in item.data"
                      v-show="!item.header"
                      v-bind:key="value"
                      class="text-center"
                    >
                      {{ value }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="pt-6">
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <h1 class="text-primary">Forecast</h1>
              </v-col>
              <v-col cols="12">
                <h4 class="text-primary">
                  Period: {{ datePeriod[0] + " - " + datePeriod[1] }}.
                </h4>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row justify="end">
              <v-col cols="12"></v-col>
              <v-col cols="9" xl="9" md="8" class="pt-0">
                <v-row justify="end">
                  <v-col cols="6" xl="6" md="10">
                    <select
                      v-show="!table"
                      name="LeaveType"
                      @change="onChange2($event)"
                      class="form-control minimal"
                      v-model="value3"
                    >
                      <option
                        v-for="item in value3Opcions"
                        :value="item"
                        v-bind:key="item"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="3" xl="3" md="4" class="text-right">
                <v-row justify="end">
                  <v-col cols="12">
                    <v-row>
                      <v-col
                        cols="6"
                        lg="6"
                        md="12"
                        sm="12"
                        class="py-1 text-right pr-0 button-group-login"
                      >
                        <v-btn
                          :rounded="0"
                          :style="
                            table
                              ? 'background-color: var(--text-2)'
                              : 'background-color: var(--text)'
                          "
                          min-width="100%"
                          outlined
                          class="rounded-l-xl elevation-0"
                          @click="table = false"
                        >
                          <p class="text-white login-text">Chart</p>
                        </v-btn>
                      </v-col>
                      <v-col cols="6" class="py-1 text-center pl-0">
                        <v-btn
                          :rounded="0"
                          outlined
                          class="rounded-r-xl elevation-0"
                          :style="
                            table
                              ? 'background-color: var(--text)'
                              : 'background-color: var(--text-2)'
                          "
                          min-width="100%"
                          @click="table = true"
                          ><p class="text-white login-text">Table</p></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"> </v-col>
          <v-col cols="12"></v-col>
          <v-col cols="12" v-show="table">
            <v-card contained-text variant="outlined">
              <v-table class="pa-0">
                <thead>
                  <tr>
                    <th class="text-center" style="width: 20%">Indicator</th>
                    <th
                      v-for="item in header2"
                      v-bind:key="item"
                      class="text-center"
                    >
                      <div style="width: 100px">{{ item }}</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in desserts2" :key="item.name">
                    <td
                      v-if="item.header"
                      class="text-left"
                      style="
                        background-color: var(--bg-2);
                        font-family: var(--f-body);
                        color: var(--text);
                        font-weight: bold;
                        font-size: 16px !important;
                      "
                    >
                      {{ item.name }}
                    </td>
                    <td
                      v-if="!item.header"
                      class="text-left"
                    >
                      {{ item.name }}
                    </td>
                    <td
                      v-for="a in item.data"
                      v-show="item.header"
                      v-bind:key="a"
                      class="text-center"
                      style="background-color: var(--bg-2)"
                    ></td>
                    <td
                      v-for="value in item.data"
                      v-show="!item.header"
                      v-bind:key="value"
                      class="text-center"
                    >
                      {{ new Intl.NumberFormat("en-US").format(value) }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </v-card>
          </v-col>
          <v-col cols="12" v-show="!table" class="text-center">
            <v-row justify="center">
              <v-col cols="6" xl="8" md="12"
                ><div
                  class="text-center"
                  id="container"
                  style="width: 100%; height: 350px"
                ></div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" v-show="header2.length > 0">
            <v-btn
              @click="saveCsv()"
              rounded
              class="elevation-0"
              color="primary"
              >download</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import anychart from "anychart";
import $ from "jquery";

export default {
  name: "consensus-report",
  components: {},
  data() {
    return {
      value: {},
      value3: "5-Year CDS",
      value3Opcions: [],
      items: [
        {
          name: "Brazil",
          consensusReport: "Brazil - Consensus",
        },
        {
          name: "Chile",
          consensusReport: "Chile - Consensus",
        },
      ],
      desserts: [],
      labels: ["12am", "3am", "6am", "9am", "12pm", "3pm", "6pm", "9pm"],
      value2: [200, 675, 410, 390, 310, 460, 250, 240],
      period: "01/07/2020 - 31/07/2020",
      table: true,
      header: [],
      header2: [],
      desserts2: [],
      header3: [],
      desserts3: [],
      data: [],
      datePeriod: ["", ""],
      save: false,
      fe_forecast: [],
      last_semester: [],
    };
  },
  methods: {
    ...mapActions([
      "setCountriesConsensus",
      "setDataConsensus",
      "setDataConsensusResult",
      "setVariableVisualizatoin",
      "setDataVisualization",
      "exportExcelConsensus",
      "setDataFeForecast",
      "setDataLastSemester",
    ]),
    drawChar() {
      let data = this.dataFormated;
      let data_fe_forecast = this.feForecastFormated;
      let data_last_semester = this.lastSemesterFormated;
      let title_value = this.value3;
      var chart = "";
      $("#container").html("");

      anychart.onDocumentReady(function () {
        // create a pie chart
        chart = anychart.line();

        var data3 = chart.line(data_last_semester);
        data3.name("Last Semester");

        var data1 = chart.line(data);
        data1.name("Consensus");
        data1.color("var(--text)");

        var data2 = chart.line(data_fe_forecast);
        data2.name("TE Forecast");

        // auto-scale the y-axis tightly to the data range so differences show.
        chart.yScale().minimumGap(0.1).maximumGap(0.1);
        chart.title("Consensus Report " + title_value);
        chart.tooltip().format("{%Value}");
        chart.legend().enabled(true).fontSize(13).padding([0, 0, 10, 0]);
        // set the container where chart will be drawn
        chart.container("container");
        //  draw the chart on the page
        chart.draw();
      });
      if (this.save) {
        chart.saveAsPng({
          width: 1000,
          height: 500,
          quality: 0.3,
          filename: "Consensus Report " + title_value,
        });
        this.save = false;
      }
    },

    onChange() {
      this.setDataConsensus(this.value.consensusReport);
    },
    onChange2() {
      this.drawChar();
    },
    saveCsv() {
      if (this.table) {
        let header = [];
        let header2 = [];
        for (let i = 0; i < this.header[0].length; i++) {
          header.push(this.header[0][i]);
        }
        for (let i = 0; i < this.header2.length; i++) {
          header2.push(this.header2[i]);
        }

        this.exportExcelConsensus({
          data: JSON.stringify(this.desserts),
          headers: header,
          data2: JSON.stringify(this.desserts2),
          headers2: header2,
        });
      } else {
        this.savePng();
      }
    },
    savePng() {
      this.save = true;
      this.drawChar();
    },
  },
  computed: {
    ...mapGetters([
      "getcontriesConsensus",
      "getdataConsensus",
      "getdataConsensusResult",
      "getVariableVisualization",
      "getdataVizualization",
      "getUrlExportConsensus",
      "getFeForecast",
      "getLastSemester",
    ]),
    dataFormated() {
      let data = this.desserts2;
      let header = this.header2;
      let dataFormated = [];
      for (let i = 0; i < header.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (data[j].name == this.value3) {
            dataFormated.push([header[i], data[j].data[i]]);
          }
        }
      }

      return dataFormated;
    },

    feForecastFormated() {
      let data = this.fe_forecast;
      let dataFormated = [];
      if (data[this.value3] != undefined) {
        for (let i = 0; i < Object.keys(data[this.value3]).length; i++) {
          dataFormated.push([
            Object.keys(data[this.value3])[i],
            data[this.value3][Object.keys(data[this.value3])[i]],
          ]);
        }
      }

      return dataFormated;
    },

    lastSemesterFormated() {
      let data = this.last_semester;
      let dataFormated = [];
      if (data[this.value3] != undefined) {
        for (let i = 0; i < Object.keys(data[this.value3]).length; i++) {
          dataFormated.push([
            Object.keys(data[this.value3])[i],
            data[this.value3][Object.keys(data[this.value3])[i]],
          ]);
        }
      }

      return dataFormated;
    },

    getcontriesConsensusFilter: function () {
      return this.getcontriesConsensus.filter(
        (i) => i.consensusReportFilter === true
      );
    },
  },
  created() {
    console.log("consensus");
  },
  watch: {
    table(val) {
      if (!val) {
        this.drawChar();
      } else {
        this.drawChar();
      }
    },
    value: function () {
      this.setDataConsensus(this.value.consensusReport);
      this.setDataConsensusResult(this.value.consensusReportResult);
      this.setDataFeForecast(this.value.consensusReportResult);
      this.setDataLastSemester(this.value.consensusReportResult);
    },
    getcontriesConsensus: function (val) {
      this.value = val[0];
    },
    getdataConsensus: function (val) {
      let data = JSON.parse(val);
      if (Object.keys(data).length > 0) {
        this.header = [];

        this.header.push(Object.keys(data));

        let name = Object.keys(data[this.header[0][0]]);

        let newData = [];

        for (let i = 0; i < name.length; i++) {
          let obj = {};
          obj.name = name[i];
          obj.data = [];
          obj.header = false;
          for (let j = 0; j < this.header[0].length; j++) {
            if (data[this.header[0][j]][name[i]] != null)
              obj.data.push(
                new Intl.NumberFormat("en-US").format(
                  data[this.header[0][j]][name[i]].toFixed(2)
                )
              );
            else obj.data.push(data[this.header[0][j]][name[i]]);
            if (data[this.header[0][j]][name[i]] == null) {
              obj.header = true;
            }
          }
          newData.push(obj);
        }
        this.desserts = newData;
      }
    },

    getdataConsensusResult: function (val) {
      let data = JSON.parse(val);
      if (Object.keys(data).length > 0) {
        this.header2 = [];
        let newHeader = [];
        for (
          let i = 0;
          i < Object.keys(data[Object.keys(data)[0]]).length;
          i++
        ) {
          newHeader.push(data[Object.keys(data)[0]][i]);
        }
        this.header2 = newHeader;
        let newData = [];

        for (let j = 1; j < Object.keys(data).length; j++) {
          let obj = {};
          obj.name = Object.keys(data)[j];
          obj.data = [];
          obj.header = false;
          for (let i = 0; i < this.header2.length; i++) {
            obj.data.push(data[Object.keys(data)[j]][i].toFixed(2));
          }
          newData.push(obj);
        }

        this.desserts2 = newData;
        this.datePeriod[0] = this.header2[0].replaceAll("-", "/");
        this.datePeriod[1] = this.header2[this.header2.length - 1].replaceAll(
          "-",
          "/"
        );
        let nuw_value = [];
        for (let i = 0; i < this.desserts2.length; i++) {
          nuw_value.push(this.desserts2[i].name);
        }
        this.value3Opcions = nuw_value;
      }
    },
    getdataVizualization: function (val) {
      let data = JSON.parse(val);

      let newData = [];
      for (let i = 0; i < Object.keys(data).length; i++) {
        newData.push([Object.keys(data)[i], data[Object.keys(data)[i]]]);
      }
      this.data = newData;
      this.drawChar();
    },
    getUrlExportConsensus: function (val) {
      if (val != "") {
        window.open(val, "_blank");
      }
    },

    getFeForecast: function (val) {
      let data = JSON.parse(val);
      this.fe_forecast = data;
    },

    getLastSemester: function (val) {
      let data = JSON.parse(val);
      this.last_semester = data;
    },
  },
  mounted() {
    this.setCountriesConsensus();
  },
};
</script>

<style scoped>
table thead tr th {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
  font-size: 16px !important;
  width: 100px;
}
table tbody tr td {
  font-family: var(--f-body);
  color: var(--text);
  font-weight: bold;
}

table > tbody > tr > td:nth-child(1) {
  position: sticky;
  left: 0;
  background: var(--bg-2);
}
table > thead > tr > th:nth-child(1) {
  position: sticky;
  left: 0;
  background: var(--bg-2);
}

select.minimal {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

select.minimal:focus {
  background-image: linear-gradient(45deg, green 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, green 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em,
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: green;
  outline: 0;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}
</style>